import styles from "./style.module.scss";
import classNames from "classnames";
interface ContainerHeaderLayoutProps {
  upperRow: React.ReactNode;
  lowerRow?: React.ReactNode;
  className?: string;
  upperRowClassName?: string;
}
export default function ContainerHeaderLayout({
  upperRow,
  lowerRow,
  className,
  upperRowClassName,
}: ContainerHeaderLayoutProps) {
  return (
    <div className={classNames(styles.containerHeader, className)}>
      <div className={`${styles.upperRow} ${upperRowClassName || ""}`}>
        {upperRow}
      </div>
      {lowerRow && <div className={styles.lowerRow}>{lowerRow}</div>}
    </div>
  );
}
